'use client';

import { ReactNode, createContext, useEffect, useState } from 'react';

import { ApplicationConfig } from '@/utils/configClient.types';
import getApplicationConfig from '@/utils/configClient';
import { storeBrowserInfo } from '@/utils/storageUtils';

export const ApplicationConfigContext = createContext<ApplicationConfig | undefined>(undefined);

export function ApplicationConfigProvider({ children }: { children: ReactNode }) {
	const [state, setState] = useState<ApplicationConfig>();

	useEffect(() => {
		const setConfig = async () => {
			const config = await getApplicationConfig();
			setState(config);
		};
		storeBrowserInfo();
		setConfig();
	});

	return (
		<ApplicationConfigContext.Provider value={state}>{children}</ApplicationConfigContext.Provider>
	);
}
